import { FormActions } from './Actions';
import { AvatarInput } from './AvatarInput';
import { Checkbox } from './Checkbox';
import { Form as FormComponent } from './Form';
import { FormMemberPicker } from './FormMemberPicker';
import { FormSpacePicker } from './FormSpacePicker';
import { SimpleHtmlEditor, } from './HtmlEditor/SimpleHtmlEditor';
import { Input } from './Input';
import { Multiselect } from './Multiselect';
import { RadioGroup } from './Radio';
import { Select } from './Select';
import { Textarea } from './Textarea';
import { Toggle } from './Toggle';
export * from './typings';
export const Form = FormComponent;
Form.Avatar = AvatarInput;
Form.Checkbox = Checkbox;
Form.Input = Input;
Form.MemberPicker = FormMemberPicker;
Form.RadioGroup = RadioGroup;
Form.Select = Select;
Form.SpacePicker = FormSpacePicker;
Form.Textarea = Textarea;
Form.Toggle = Toggle;
Form.Actions = FormActions;
Form.Multiselect = Multiselect;
Form.SimpleHtmlEditor = SimpleHtmlEditor;
//# sourceMappingURL=index.js.map